import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
// import { InitialsIcon } from '../../Header/style';
import { Text } from './style';

const NotificationTable = ({ columns, rows }) => {
  const filterRows = rows ? rows.filter(item => item != null) : []
  return (
    <TableContainer style={{ maxHeight: '250px' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {columns &&
              columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filterRows &&
            filterRows.map(({ processDescription, processInstanceId, documentDescription, documentUrl }, index) => (
              <TableRow key={index} style={{ cursor: 'pointer' }} onClick={() => window.open(documentUrl, '_blank').focus()}>
                <TableCell align="left">
                  <Text>{(processInstanceId) ? `${processInstanceId} - ` : ''}{processDescription}</Text>
                </TableCell>
                <TableCell align="left">
                  <Text>{documentDescription?.substring(0, documentDescription.indexOf(' -') + 1)}</Text>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NotificationTable;
